import './popper.js';
import tippy from './tippy.js';

const OpaccPopperTooltip = tippy;
export default OpaccPopperTooltip;
